import useLocales from 'hooks/useLocales';
import React, { FC, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { FormFieldType } from 'core/interface/formFieldType';

import './Index.scss';

const FormField: FC<FormFieldType> = ({
  fieldName,
  type,
  placeholder,
  className,
  inputClassName,
  disabled = false
}): JSX.Element => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const formik = useFormikContext<{ [key: string]: string }>();
  const { t } = useLocales();

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  return (
    <div className={className ?? 'field'}>
      <div className="input-container">
        <Field
          disabled={disabled}
          className={`${inputClassName ?? ''} ${
            formik.errors[fieldName] && formik.touched[fieldName] ? 'error' : ''
          }`}
          type={isPasswordVisible && type === 'password' ? 'text' : type}
          name={fieldName}
          placeholder={t(placeholder) || placeholder}
          style={{ color: '#2a2a2a' }}
        />
        {type === 'password' && (
          <button
            type="button"
            onClick={togglePasswordVisibility}
            className="toggle-password-button"
          >
            {t(isPasswordVisible ? 'Hide' : 'Show')}
          </button>
        )}
      </div>
      {formik.errors[fieldName] && formik.touched[fieldName] && (
        <div className="error-container">
          <span className="error-message-form-field"> {t('required')} </span>
        </div>
      )}
    </div>
  );
};

export default FormField;
